<template>
  <div>
  <div class="frame" ref='frame'>
    <h2 class="head">Draw a firework</h2>
    <div v-for="n in width*height" :style="pixelStyle(n)" class="pixel" :key='n' v-on:click="pixelClicked(n)"></div>
    <label v-for="color in colors" :key="color" :style="'color: '+color">X
    <input type="radio"  v-model="selectedColor" :value="color" />
    </label>
    <button v-on:click="fireworks = {}">clear</button>
    <slot></slot>
  </div>
  </div>
</template>

<script>

export default {
  name: 'DrawFirework',
  data () {
    return {
      frameWidth: 0,
      frameHeight: 0,
      width: 8,
      height: 8,
      colors: [
        '#ff0000',
        '#0000ff',
        '#ffff00',
        '#00ff00'
      ],
      fireworks: {},
      selectedColor: '#ff0000'
    }
  },
  mounted () {
    this.frameWidth = this.$refs.frame.offsetWidth
    this.frameHeight = this.$refs.frame.offsetHeight
  },
  computed: {
    normalizedVector () {
      let vectors = []
      for (const [key, value] of Object.entries(this.fireworks)) {
        let v = this.vectorize(key)
        v[0] = (v[0] - (this.width - 1.0) / 2.0) / ((this.width - 1.0) / 2.0)
        v[1] = (v[1] - (this.height - 1) / 2.0) / ((this.height - 1.0) / 2.0)
        vectors.push({ vector: v, color: value })
      }
      return vectors
    }
  },
  methods: {
    pixelClicked (n) {
      if (this.fireworks[n] === this.selectedColor) {
        this.$delete(this.fireworks, n)
        return
      }
      this.$set(this.fireworks, n, this.selectedColor)
    },
    pixelStyle (n) {
      let coordinates = this.vectorize(n)
      let style = {
        'box-sizing': 'border-box',
        'border-color': 'white',
        'border-width': '0.5px',
        'border-style': 'solid',
        'width': `${this.frameWidth / this.width}px`,
        'height': `${this.frameHeight / this.height}px`
      }
      if (n in this.fireworks) {
        style['background-color'] = this.fireworks[n]
      }
      if (coordinates[1] === Math.floor((this.height) / 2) - 1) {
        style['border-bottom-width'] = '3px'
      }
      if (coordinates[0] === Math.floor((this.width) / 2) - 1) {
        style['border-right-width'] = '3px'
      }
      return style
    },
    vectorize (n) {
      n = n - 1
      let x = n % this.width
      let y = Math.floor(n / this.width)
      return [x, y]
    }
  },
  watch: {
    normalizedVector: function (val) {
      this.$emit('update-firework', val)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .frame {
   width: 250px;
   height: 250px;
   background-color: black;
 }
.pixel {
  display: inline-block;
}
.head {
  color:#ffffff;
  font-family:Courier New;
  font-size:17px;
  font-weight:bold;
  text-decoration:none;
  text-shadow:0px 1px 0px #646464;
  padding: 0;
  margin: 0;
}
</style>
